import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "media-left image is-96x96" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "media-content" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Order Document Id: ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Product Reservation Id: ")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { key: 3 }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" User Id: ")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { key: 4 }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Partition Key: ")
const _hoisted_20 = { class: "media-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("figure", _hoisted_1, [
      _createElementVNode("strong", {
        class: _normalizeClass({ 'has-text-white': _ctx.isDark })
      }, _toDisplayString(_ctx.listing.OrderReferenceNumber), 3),
      _hoisted_2,
      _createElementVNode("small", {
        class: _normalizeClass(["has-text-weight-bold py-1", { 'has-text-primary': _ctx.isDark, 'has-text-info': !_ctx.isDark }])
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.listing.LastStatus), 1)
      ], 2),
      _hoisted_3,
      (_ctx.listing.LastUpdateDate)
        ? (_openBlock(), _createElementBlock("code", _hoisted_4, _toDisplayString(_ctx.formatDate(_ctx.listing.LastUpdateDate)), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", {
          class: _normalizeClass({ 'has-text-white': _ctx.isDark })
        }, [
          (_ctx.listing.CreatedDate)
            ? (_openBlock(), _createElementBlock("small", _hoisted_7, " Requested Date: " + _toDisplayString(_ctx.formatDate(_ctx.listing.CreatedDate)), 1))
            : _createCommentVNode("", true),
          _hoisted_8,
          (_ctx.listing.OrderDocumentId)
            ? (_openBlock(), _createElementBlock("small", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("code", null, _toDisplayString(_ctx.listing.OrderDocumentId), 1)
              ]))
            : _createCommentVNode("", true),
          _hoisted_11,
          (_ctx.listing.ProductReservationId)
            ? (_openBlock(), _createElementBlock("small", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("code", null, _toDisplayString(_ctx.listing.ProductReservationId), 1)
              ]))
            : _createCommentVNode("", true),
          _hoisted_14,
          (_ctx.listing.UserId)
            ? (_openBlock(), _createElementBlock("small", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("code", null, _toDisplayString(_ctx.listing.UserId), 1)
              ]))
            : _createCommentVNode("", true),
          _hoisted_17,
          (_ctx.listing.PartitionKey)
            ? (_openBlock(), _createElementBlock("small", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("code", null, _toDisplayString(_ctx.listing.PartitionKey), 1)
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      (_ctx.listing.OrderReferenceNumber)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: { name: 'OrderDetails', params : { id: _ctx.listing.OrderReferenceNumber } }
          }, {
            default: _withCtx(() => [
              _createElementVNode("strong", {
                class: _normalizeClass({ 'has-text-white': _ctx.isDark })
              }, [
                _createElementVNode("button", {
                  class: _normalizeClass(["button is-light is-small", { 'is-primary': _ctx.isDark, 'is-info': !_ctx.isDark}])
                }, " Details ", 2)
              ], 2)
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}